import axios from 'axios';
import { ECOMMERCE_CONFIG, ecommerceError } from '../../config/EcommerceConfig';

/**
 * Servicio para obtener información pública de la empresa
 * Conecta con EmpresaController del backend
 */
export const EcommerceEmpresaService = {
    /**
     * Obtiene información pública de la empresa principal (primera empresa creada)
     * @returns {Promise<Object>} Datos de la empresa (logo, nombre, moneda, etc.)
     */
    obtenerEmpresaPrincipal: async () => {
        try {
            const url = `${ECOMMERCE_CONFIG.API_BASE_URL}/api/empresas/public`;
            
            const response = await axios.get(url, {
                timeout: ECOMMERCE_CONFIG.REQUEST_TIMEOUT
            });
            
            if (response.data?.success && response.data?.data) {
                return response.data.data;
            }
            return null;
        } catch (error) {
            ecommerceError(`Error al obtener empresa principal: ${error.message}`, error);
            throw error;
        }
    },

    /**
     * Obtiene información pública de una empresa específica
     * @param {number} idEmpresa - ID de la empresa
     * @returns {Promise<Object>} Datos de la empresa
     */
    obtenerEmpresaPorId: async (idEmpresa = ECOMMERCE_CONFIG.EMPRESA_ID) => {
        try {
            const url = `${ECOMMERCE_CONFIG.API_BASE_URL}/api/empresas/public`;
            
            const response = await axios.get(url, {
                timeout: ECOMMERCE_CONFIG.REQUEST_TIMEOUT
            });
            
            if (response.data?.success && response.data?.data) {
                return response.data.data;
            }
            return null;
        } catch (error) {
            ecommerceError(`Error al obtener empresa: ${error.message}`, error);
            throw error;
        }
    }
};
